// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2d0yE","FForbid":"FForbid___1MJez","content":"content___3nQyq"};